import { Component } from '@angular/core';

@Component({
  selector: 'app-reporting-sidebar',
  templateUrl: './reporting-sidebar.component.html',
  styleUrls: ['./reporting-sidebar.component.scss']
})
export class ReportingSidebarComponent {

}
